require('./bootstrap');

window.Vue = require('vue');
import Vuex from 'vuex'
import VueCharts from 'vue-chartjs';
import VueClipboard from 'vue-clipboard2';
import { VTooltip } from 'v-tooltip'
import VueTelInput from 'vue-tel-input'
import VueCurrencyInput from 'vue-currency-input'
import StoreData from './store'
import {initialize} from './general';
import InfiniteLoading from 'vue-infinite-loading'

Vue.use(VueCurrencyInput)
Vue.use(Vuex)
Vue.use(VueTelInput)
Vue.directive('tooltip', VTooltip)
import money from 'v-money'
Vue.use(money, {
  precision: 2,
  decimal: '.',
  thousands: ',',
  prefix: ''
});
Vue.use(InfiniteLoading, {
  slots: {
    noMore: '', // you can pass a string value
    noResults: '', // you also can pass a Vue component as a slot
  },
})

VueClipboard.config.autoSetContainer = true; // add this line
import PerfectScrollbar from 'perfect-scrollbar';

$.fn.perfectScrollbar = function (options) {
  return this.each((k, elm) => new PerfectScrollbar(elm, options || {}));
};

// register the plugin on vue
import Toasted from 'vue-toasted';
Vue.use(Toasted, {
  duration: '3000'
});

const store = new Vuex.Store(StoreData)
initialize(store);

import Raphael from 'raphael/raphael';
global.Raphael = Raphael;

import fontawesome from '@fortawesome/fontawesome';
import regular from '@fortawesome/fontawesome-free-regular';
import solid from '@fortawesome/fontawesome-free-solid';
import brands from '@fortawesome/fontawesome-free-brands';
import VueTimeago from 'vue-timeago';

Vue.use(VueClipboard);

jQuery.extend(true, jQuery.fn.datetimepicker.defaults, {
    icons: {
      time: 'far fa-clock',
      date: 'far fa-calendar',
      up: 'fas fa-arrow-up',
      down: 'fas fa-arrow-down',
      previous: 'fas fa-chevron-left',
      next: 'fas fa-chevron-right',
      today: 'fas fa-calendar-check',
      clear: 'far fa-trash-alt',
      close: 'far fa-times-circle'
    },
    useCurrent: false,
    format: 'DD-MM-YYYY HH:mm:ss',
    locale: 'es'
});

Vue.use(VueTimeago, {
  locale: 'es',
  locales: {
    'es': require('date-fns/locale/es'),
  }
})

fontawesome.library.add(regular);
fontawesome.library.add(solid);
fontawesome.library.add(brands);

Vue.mixin({
  methods: {
    money(value, symbol=false) {
      //val = value.toFixed(2).replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      let num = (value/1).toFixed(2);
      let val = num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
      var money = '';
      
      if (symbol) {
        return (crm.money || 'Q') + val;
      }

      return val;
      //return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
    },
    roleUser() {
      return crm.role;
    },

    configuracionBase(){
      return JSON.parse(crm.configuracionBase.replace(/&quot;/g,'"'))
    },

    parseDecimal(val){
      if (!val) {return 0}
      let num = val.toString().replace(/[#,]/g,'')
      return parseFloat((num/1).toFixed(2));
    },
  }
});

Vue.filter('money', function(value){
  var data = value ? value : 0
  let num = (data/1).toFixed(2);
  let val = num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,');
  return 'Q' + val;
});

Vue.component('create-prospecto', require('./components/crm/clientes/Create.vue').default);
Vue.component('cliente-edit', require('./components/crm/clientes/Edit.vue').default);
Vue.component('campanas-events', require('./components/crm/campanas/Index.vue').default);

Vue.component('consultas-pivot', require('./components/crm/consultas/Pivot.vue').default);

Vue.component('consultar-cliente-modal', require('./components/crm/clientes/ShowModal.vue').default);
Vue.component('consultar-inversor-modal', require('./components/crm/inversores/Show.vue').default);
Vue.component('consultar-cliente', require('./components/crm/clientes/Show.vue').default);
Vue.component('consultar-vendedor', require('./components/crm/vendedores/Show.vue').default);
Vue.component('consultar-producto', require('./components/crm/productos/Show.vue').default);
Vue.component('consultar-oportunidad', require('./components/crm/oportunidades/Show.vue').default);
Vue.component('edit-fecha-gano', require('./components/crm/oportunidades/EditFechaFin.vue').default);

Vue.component('create-ejecutivo', require('./components/crm/ejecutivo/Create.vue').default);
Vue.component('create-corporacion', require('./components/crm/corporaciones/Create.vue').default);
Vue.component('select2', require('./components/crm/plugins/select2.vue').default);
Vue.component('line-chart', require('./components/crm/plugins/Charts/Line.vue').default);
Vue.component('pie-chart', require('./components/crm/plugins/Charts/Pie.vue').default);
Vue.component('doughnut-chart', require('./components/crm/plugins/Charts/Doughnut.vue').default);

Vue.component('oportunidades', require('./components/crm/oportunidades/Index.vue').default);

Vue.component('morris-donut', require('./components/crm/plugins/Morris/Donut.vue').default);
Vue.component('morris-line', require('./components/crm/plugins/Morris/Line.vue').default);

Vue.component('notifications-demo', require('./components/crm/Notifications/NotificationsDemo.vue').default);
Vue.component('notifications-dropdown', require('./components/crm/Notifications/NotificationsDropdown.vue').default);

Vue.component('add-event', require('./components/crm/calendar/Index.vue').default);///
Vue.component('autocomplete', require('./components/crm/plugins/AutoCompleteEmail.vue').default);

Vue.component('publicaciones-disponibles', require('./components/crm/publicaciones/Disponibles.vue').default);
Vue.component('publicaciones', require('./components/crm/publicaciones/Index.vue').default);
Vue.component('tareas', require('./components/crm/tareas/index2.vue').default);
Vue.component('tareas-adjuntos', require('./components/crm/tareas/Adjuntos.vue').default);
Vue.component('encuestas-detalle', require('./components/crm/encuestas-detalle/index.vue').default);
Vue.component('data-encuestas-detalle', require('./components/crm/encuestas-detalle/dataTable.vue').default);

Vue.component('datetime', require('./components/crm/plugins/datetime.vue').default);

Vue.component('agenda', require('./components/plugins/calendar/agenda.vue').default);
Vue.component('agenda-modal', require('./components/plugins/calendar/Modal.vue').default);
Vue.component('calendario', require('./components/plugins/calendar/calendar.vue').default);
Vue.component('date-picker', require('./components/crm/plugins/date.vue').default);

Vue.component('empty', require('./components/emptyEstate.vue').default);
Vue.component('empty-search', require('./components/emptySearch.vue').default);
Vue.component('preloader', require('./components/preloader.vue').default);
Vue.component('copy', require('./components/plugins/copy.vue').default);
Vue.component('button-copy', require('./components/plugins/copyButon.vue').default);
Vue.component('emails', require('./components/plugins/emails.vue').default);
Vue.component('errors', require('./components/plugins/errors.vue').default);
Vue.component('wrapper', require('./components/plugins/wrapper.vue').default);
Vue.component('decimal', require('./components/plugins/Decimal.vue').default);
Vue.component('integer', require('./components/plugins/Integer.vue').default);
Vue.component('phone', require('./components/plugins/Telefono.vue').default);
Vue.component('password', require('./components/plugins/Password.vue').default);
Vue.component('editor-texto', require('./components/plugins/EditorTexto.vue').default);

Vue.component('context-menu', require('./components/ContextMenu.vue').default);

Vue.component('box-header', require('./components/plugins/HeaderCard.vue').default);

Vue.component('card', require('./components/template/cards/Card.vue').default);
Vue.component('card-header', require('./components/template/cards/CardHeader.vue').default);
Vue.component('card-body', require('./components/template/cards/CardBody.vue').default);
Vue.component('card-footer', require('./components/template/cards/CardFooter.vue').default);

Vue.component('data-tables', require('./components/plugins/dataTable.vue').default);
//Clientes Bases
Vue.component('clientes-bases', require('./components/crm/clientes-bases/Index.vue').default);
Vue.component('create-clientes-bases', require('./components/crm/clientes-bases/Create.vue').default);
Vue.component('change-client', require('./components/crm/clientes-bases/Change.vue').default);
Vue.component('btn-edit-client', require('./components/crm/clientes-bases/ButtonEdit.vue').default);
Vue.component('edit-clientes-bases', require('./components/crm/clientes-bases/Edit.vue').default);

Vue.component('button-group', require('./components/crm/plugins/Buttons/Group.vue').default);
Vue.component('button-show', require('./components/crm/plugins/Buttons/Show.vue').default);
Vue.component('button-edit', require('./components/crm/plugins/Buttons/Edit.vue').default);
Vue.component('button-delete', require('./components/crm/plugins/Buttons/Delete.vue').default);

/**Components Fields**/
Vue.component('auditoria', require('./components/crm/plugins/Fields/Auditoria.vue').default);
Vue.component('view-info', require('./components/crm/plugins/Fields/ViewInfo.vue').default);

Vue.component('usuarios-clientes', require('./components/crm/usuarios-clientes/Index.vue').default);
Vue.component('usuario', require('./components/crm/usuarios/consulta.vue').default);

Vue.component('usuario-roles-permisos', require('./components/crm/usuarios/roles/Index.vue').default);
Vue.component('roles', require('./components/crm/roles/Index.vue').default);

Vue.component('upload-logo', require('./components/crm/configuracion/UploadLogo.vue').default);

Vue.component('clientes-avatar', require('./components/crm/clientes/UploadAvatar.vue').default);
Vue.component('environment-vars', require('./components/crm/Environment/Index.vue').default);

//Detalles
Vue.component('oportunidades-personas', require('./components/crm/Oportunidades/personas/Index.vue').default);
Vue.component('oportunidades-danos', require('./components/crm/Oportunidades/danos/Index.vue').default);
Vue.component('oportunidades-detalle', require('./components/crm/Oportunidades/detalle/Index.vue').default);
Vue.component('oportunidad-detalle-rapido', require('./components/crm/Oportunidades/detalle/Rapido.vue').default);
Vue.component('oportunidades-polizas', require('./components/crm/Oportunidades/polizas/Index.vue').default);
Vue.component('oportunidades-prestamo', require('./components/crm/Oportunidades/prestamo/Edit.vue').default);
Vue.component('oportunidad-prerequisitos', require('./components/crm/Oportunidades/prestamo/PreRequisitos.vue').default);

Vue.component('polizas-edit', require('./components/crm/polizas/Edit.vue').default);

Vue.component('catalogo-usuarios', require('./components/crm/catalogos/Usuarios.vue').default);
Vue.component('catalogo-correos', require('./components/crm/catalogos/Correos.vue').default);
Vue.component('catalogo-aseguradoras', require('./components/crm/catalogos/Aseguradoras.vue').default);
Vue.component('catalogo-tipos-tareas', require('./components/crm/catalogos/TiposTareas.vue').default);
Vue.component('catalogo-endosos', require('./components/crm/catalogos/Endosos.vue').default);
Vue.component('catalogo-clientes', require('./components/crm/catalogos/Clientes.vue').default);
Vue.component('catalogo-tipos-polizas', require('./components/crm/catalogos/TiposPolizas.vue').default);
Vue.component('catalogo-tipos-endosos', require('./components/crm/catalogos/TiposEndosos.vue').default);
Vue.component('catalogo-vendedores', require('./components/crm/catalogos/Vendedores.vue').default);
Vue.component('catalogo-vendedores-todos', require('./components/crm/catalogos/TodosVendedores.vue').default);
Vue.component('catalogo-productos', require('./components/crm/catalogos/Productos.vue').default);
Vue.component('catalogo-corporaciones', require('./components/crm/catalogos/Corporaciones.vue').default);
Vue.component('catalogo-formas-pagos', require('./components/crm/catalogos/FormasPagos.vue').default);
Vue.component('catalogo-sucursales', require('./components/crm/catalogos/Sucursales.vue').default);
Vue.component('catalogo-etapas', require('./components/crm/catalogos/Etapas.vue').default);
Vue.component('catalogo-clientes-enlaces', require('./components/crm/catalogos/CrmEnlaces.vue').default);
Vue.component('catalogo-campanas', require('./components/crm/catalogos/Campanas.vue').default);
Vue.component('catalogo-medios', require('./components/crm/catalogos/Medios.vue').default);
Vue.component('catalogo-razones', require('./components/crm/catalogos/Razones.vue').default);
Vue.component('catalogo-ejecutivos', require('./components/crm/catalogos/Ejecutivos.vue').default);
Vue.component('catalogo-intermediarios', require('./components/crm/catalogos/Intermediarios.vue').default);
Vue.component('catalogo-intermediarios-ejecutivos', require('./components/crm/catalogos/EjecutivoIntermediario.vue').default);
Vue.component('catalogo-grupo-productos', require('./components/crm/catalogos/GrupoProductos.vue').default);
Vue.component('catalogo-grupo-ventas', require('./components/crm/catalogos/GrupoVentas.vue').default);
Vue.component('catalogo-subgrupo-productos', require('./components/crm/catalogos/SubGrupoProductos.vue').default);
Vue.component('catalogo-tipos-prestamos', require('./components/crm/catalogos/TiposPrestamos.vue').default);
Vue.component('catalogo-comisionistas', require('./components/crm/catalogos/Comisionistas.vue').default);
Vue.component('catalogos-inmuebles', require('./components/crm/catalogos/Inmuebles.vue').default);
Vue.component('catalogos-inversores', require('./components/crm/catalogos/Inversores.vue').default);
Vue.component('catalogos-prestamos', require('./components/crm/catalogos/Prestamos.vue').default);
Vue.component('catalogos-mensajeros', require('./components/crm/catalogos/Mensajero.vue').default);

Vue.component('catalogos-departamentos', require('./components/crm/catalogos/Departamentos.vue').default);
Vue.component('catalogos-municipios', require('./components/crm/catalogos/Municipios.vue').default);
Vue.component('catalogos-lineas', require('./components/crm/catalogos/Lineas.vue').default);
Vue.component('catalogos-marcas', require('./components/crm/catalogos/Marcas.vue').default);
Vue.component('catalogos-polizas', require('./components/crm/catalogos/Polizas.vue').default);

Vue.component('catalogo-oportunidades', require('./components/crm/catalogos/Oportunidades.vue').default);
Vue.component('catalogo-segmentos', require('./components/crm/catalogos/Segmentos.vue').default);
Vue.component('catalogo-estado-civil', require('./components/crm/catalogos/EstadoCivil.vue').default);
Vue.component('catalogo-factores-grupo', require('./components/crm/catalogos/FactoresGrupo.vue').default);

Vue.component('catalogo-factores', require('./components/crm/catalogos/Factores.vue').default);
Vue.component('catalogo-factores-columns', require('./components/crm/catalogos/FactoresColumns.vue').default);
Vue.component('catalogo-factores-valores', require('./components/crm/catalogos/FactoresValores.vue').default);

Vue.component('polizas-logs', require('./components/crm/polizas/Logs.vue').default);
Vue.component('polizas-endosos', require('./components/crm/endosos/Index.vue').default);
Vue.component('polizas-cobros-programados', require('./components/crm/polizas/cobros-programados/Index.vue').default);
Vue.component('polizas-cobros-realizados', require('./components/crm/polizas/cobros-realizados/Index.vue').default);
Vue.component('icon-group', require('./components/crm/plugins/IconGroup.vue').default);
Vue.component('img-view', require('./components/plugins/ImageView.vue').default);

Vue.component('oportunidad-tareas', require('./components/crm/oportunidades/tareas/Index.vue').default);
Vue.component('cliente-tareas', require('./components/crm/clientes/tareas/Index.vue').default);
Vue.component('cliente-logs', require('./components/crm/clientes/Logs.vue').default);

Vue.component('bien-asegurado', require('./components/crm/polizas/bien-asegurado/Index.vue').default);
Vue.component('bien-asegurado-endoso', require('./components/crm/polizas/bien-asegurado/IndexEndoso.vue').default);
Vue.component('create-bien-asegurado', require('./components/crm/polizas/bien-asegurado/Create.vue').default);

Vue.component('clientes-formularios-create', require('./components/crm/clientes/formularios/Create.vue').default);
Vue.component('clientes-formularios-edit', require('./components/crm/clientes/formularios/Edit.vue').default);

Vue.component('cliente-contactos', require('./components/crm/clientes/contactos/Index.vue').default);
Vue.component('cobros', require('./components/crm/cobros/Index.vue').default);
Vue.component('paginacion', require('./components/crm/plugins/Pagination.vue').default);

Vue.component('cobros-programados', require('./components/crm/cobros/programados/Index.vue').default);
Vue.component('cobros-realizados', require('./components/crm/cobros/realizados/Index.vue').default);

Vue.component('reporte-estado-cuenta', require('./components/crm/reportes/EstadoCuenta.vue').default);
Vue.component('fields-corporacion-cliente', require('./components/crm/reportes/CorporacionesClientes.vue').default);

Vue.component('options-nuevo', require('./components/crm/nuevo/Nuevo.vue').default);
Vue.component('update', require('./components/crm/buttons/Update.vue').default);

Vue.component('asignar-vendedor', require('./components/crm/oportunidades/AsignarVendedor.vue').default);
Vue.component('datos-compra', require('./components/crm/oportunidades/DatosCompra.vue').default);
Vue.component('metas-vendedor', require('./components/crm/vendedores/Metas.vue').default);

Vue.component('mensajes', require('./components/crm/mensajes/Show.vue').default);
Vue.component('chat-form', require('./components/crm/mensajes/ChatForm.vue').default);
Vue.component('chat-messages', require('./components/crm/mensajes/ChatMessages.vue').default);

Vue.component('grupo-factor-analisis', require('./components/crm/analisis/factores/Grupos.vue').default);
Vue.component('factor-valores', require('./components/crm/analisis/factores/Valores.vue').default);
Vue.component('factor-analisis', require('./components/crm/analisis/factores/Index.vue').default);

Vue.component('dynamic-factores', require('./components/crm/catalogos/AutoCompleteDynamic.vue').default);
Vue.component('niveles-avisos', require('./components/crm/catalogos/Niveles.vue').default);
Vue.component('calificacion-prestamos', require('./components/crm/oportunidades/prestamo/Calificacion.vue').default);

Vue.component('prestamos-cobros-programados', require('./components/crm/prestamos/cobros/programados/Index.vue').default);
Vue.component('prestamos-cobros-realizados', require('./components/crm/prestamos/cobros/realizados/Index.vue').default);
const app = new Vue({
    el: '#app',
    store
});

//window.vm = app;

require('../custom/datatables/dataTables.bootstrap4.min.js');
require('./site.js');